import apiConfig from 'constants/apiConfig';
import {
    AddContactPayload,
    BulkAddContactsPayload,
    Contact,
    ContactResponse,
    CreatorContactsFilters,
    UpdateContactMobilePayload,
} from 'types/creators';
import axiosClient from 'utils/axiosClient';

const withAgencyId = (url: string, agencyId: string) => url.replace('<agencyId>', agencyId);

export const fetchContacts = async (
    agencyId: string,
    filters?: CreatorContactsFilters
): Promise<ContactResponse> => {
    const response = await axiosClient.get(withAgencyId(apiConfig.FETCH_CONTACTS.url, agencyId), {
        params: filters,
    });
    return response.data;
};

export const addContact = async (agencyId: string, payload: AddContactPayload): Promise<any> => {
    const response = await axiosClient.post(withAgencyId(apiConfig.CREATE_CONTACT.url, agencyId), payload);
    return response.data;
};

export const bulkAddContacts = async (
    agencyId: string,
    payload: BulkAddContactsPayload
): Promise<any> => {
    const response = await axiosClient.post(
        withAgencyId(apiConfig.BULK_CREATE_CONTACT.url, agencyId),
        payload
    );
    return response.data;
};

export const updateContactTags = async (
    agencyId: string,
    socialAccountId: string,
    tags: string[]
): Promise<Contact> => {
    const response = await axiosClient.put(
        withAgencyId(apiConfig.UPDATE_CONTACT_TAGS.url, agencyId).replace(
            '<socialAccountId>',
            socialAccountId
        ),
        { tags }
    );
    return response.data;
};

export const updateContactMobile = async (
    agencyId: string,
    socialAccountId: string,
    payload: UpdateContactMobilePayload
): Promise<any> => {
    const response = await axiosClient.post(
        withAgencyId(apiConfig.UPDATE_CONTACT_MOBILE.url, agencyId).replace(
            '<socialAccountId>',
            socialAccountId
        ),
        payload
    );
    return response.data;
};
